export default __webpack_public_path__ + "static/media/photo--lg--137.26d5a2fa.jpg";